import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Variable
 */

export default function VariableIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M1.3581 4H0L1.99621 10H3.57171L5.56509 4H4.20982L2.80937 8.55859H2.75572L1.3581 4ZM6.48908 10L6.91825 8.63184H9.00481L9.43398 10H10.7441L8.7507 4H7.17519L5.17898 10H6.48908ZM7.22884 7.6416L7.94035 5.37109H7.98553L8.69705 7.6416H7.22884ZM12.6626 10H11.4401V4H13.7214C15.0344 4 15.7939 4.76758 15.7939 5.95996C15.7939 6.78027 15.4297 7.375 14.7718 7.66797L16 10H14.6504L13.5549 7.87305H12.6626V10ZM12.6626 5.03711V6.85352H13.4927C14.193 6.85352 14.5346 6.55469 14.5346 5.95996C14.5346 5.3623 14.193 5.03711 13.4871 5.03711H12.6626ZM0.533333 12C0.238781 12 0 12.2239 0 12.5C0 12.7761 0.238781 13 0.533333 13H15.4667C15.7612 13 16 12.7761 16 12.5C16 12.2239 15.7612 12 15.4667 12H0.533333Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
